import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { getDataWithDotNet } from "../../../../newApis/dotNetApiMethods";

interface IInvestmentCertificateResponse {
  data: {
    certificateUrl: string;
    url?: string;
  };
  message: string;
  status: boolean;
  status_code: number;
}

export const fetchInvestmentCertificate = async (
  investmentId: number,
): Promise<IInvestmentCertificateResponse> => {
  // TODO: Replace with actual API call when backend is ready
  // const response = await getDataWithDotNet(
  //   `${ajaxEndpoints.GET_INVESTMENT_CERTIFICATE}/${investmentId}`,
  // );
  // return response;

  // Generate dummy PDF
  return new Promise((resolve) => {
    setTimeout(() => {
      // Create a simple PDF document as base64
      const pdfContent = `
%PDF-1.4
1 0 obj
<<
/Type /Catalog
/Pages 2 0 R
>>
endobj
2 0 obj
<<
/Type /Pages
/Kids [3 0 R]
/Count 1
>>
endobj
3 0 obj
<<
/Type /Page
/Parent 2 0 R
/MediaBox [0 0 612 792]
/Contents 4 0 R
/Resources <<
/Font <<
/F1 <<
/Type /Font
/Subtype /Type1
/BaseFont /Helvetica
>>
>>
>>
>>
endobj
4 0 obj
<<
/Length 200
>>
stream
BT
/F1 24 Tf
50 700 Td
(Investment Certificate) Tj
0 -50 Td
/F1 12 Tf
(Investment ID: ${investmentId}) Tj
0 -30 Td
(This is a dummy certificate for testing purposes.) Tj
0 -30 Td
(Date: ${new Date().toLocaleDateString()}) Tj
ET
endstream
endobj
xref
0 5
0000000000 65535 f
0000000009 00000 n
0000000058 00000 n
0000000115 00000 n
0000000317 00000 n
trailer
<<
/Size 5
/Root 1 0 R
>>
startxref
567
%%EOF`;

      // Convert to blob and create URL
      const blob = new Blob([pdfContent], { type: "application/pdf" });
      const certificateUrl = URL.createObjectURL(blob);

      resolve({
        data: {
          certificateUrl,
        },
        message: "Certificate fetched successfully",
        status: true,
        status_code: 200,
      });
    }, 1000); // Simulate API delay
  });
};

const useInvestmentCertificate = (investmentId: number) => {
  return useQuery<IInvestmentCertificateResponse>(
    ["investmentCertificate", investmentId],
    () => fetchInvestmentCertificate(investmentId),
    {
      staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
      refetchOnWindowFocus: false,
      enabled: !!investmentId, // Only fetch if investmentId exists
    },
  );
};

export default useInvestmentCertificate;
